export default __webpack_public_path__ + "static/media/team.e1154fc7.png";